import * as React from 'react';
import { useMemo } from 'react';

import map from 'lodash/map';

import { Autocomplete } from '@sbv-clients/ui-shared';

import { useEmployeesGet } from '../service/hr';

export const EmployeeFilter = ({
  useContextFn,
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    facilityId?: number;
    departmentId?: number;
    employeeId: number;
    setEmployeeId: (value: number) => void;
  };
}) => {
  const {
    facilityId,
    departmentId,
    employeeId: value,
    setEmployeeId: setValue,
  } = useContextFn();
  const { data, isLoading } = useEmployeesGet({
    facilityId,
    departmentId,
  });

  const options = useMemo(
    () =>
      map(data, (item) => {
        return {
          id: item.employeeId as number,
          label: item.fullName ?? '',
          value: String(item.employeeId),
        };
      }),
    [data]
  );

  return (
    <Autocomplete
      size="small"
      isLoading={isLoading}
      value={String(value)}
      label="Search"
      options={options}
      onChange={(value) => setValue(+value)}
    />
  );
};

export default EmployeeFilter;
